import React, { useState, useEffect } from 'react';
import fetcher from '../../API';
import CategoryUtils from '../../common/CategoryUtils';
import { postImage, postCategory } from '../../services/frontCategoryService';
import { Form, Input, Modal, Upload, message, Radio, TreeSelect } from 'antd';
import { MinusCircleOutlined } from '@ant-design/icons';
import './category-modal.scss';
const { TreeNode } = TreeSelect
const TYPE = {
    BACKEND: 'BACKEND',
    SEARCH: 'SEARCH'
}
const treeSelect = (children, parentName?) => {
    return children && children.length > 0 ? (
        children.map((item, index) => {
            return (
                <TreeNode
                    value={item.category.id}
                    title={`${item.category.id}-${parentName ? parentName + '-' : ''}${item.category.displayTerm
                        }(${item.category.term})`}
                    key={item.category.id}
                >
                    {item.children &&
                        item.children.length > 0 &&
                        treeSelect(
                            item.children,
                            `${parentName ? parentName + '-' : ''}${item.category.displayTerm
                            }`
                        )}
                </TreeNode>
            )
        })
    ) : (
            <div></div>
        )
}

function ThirdModal(props) {
    const { onClose, visible, current, parentId, handleSuccess } = props || {};
    const { id, name, backendCategoryIds, q, icon, status } = current || {};
    const [form] = Form.useForm();
    const [submitting, setSubmitting] = useState(false);
    const [type, setType] = useState(q ? TYPE.SEARCH : TYPE.BACKEND);
    const [categories, setCategory]: any = useState();
    const [categoryNameMap, setCategoryNameMap] = useState({});
    const [categroyIcon, setCategroyIcon]: any = useState(icon|| null);
    const cMap = {};

    useEffect(() => {
        fetchCateGoryTree();
    }, []);

    useEffect(() => {
        if(current) {
            form.setFieldsValue(current);
        }
    }, [current])

    const formItemLayout = {
        labelCol: {
            xs: { span: 24 },
            sm: { span: 6 },
        },
        wrapperCol: {
            xs: { span: 24 },
            sm: { span: 12 },
        },
    };

    function handleSubmit() {
        form.validateFields()
            .then((values) => {
                if(submitting) return null;
                setSubmitting(true);
                const data = {
                    ...values,
                    parentId: parentId || current?.parentId,
                    id: id || null,
                    icon: categroyIcon,
                    priority: current?.priority || 0
                };
                if(type === TYPE.BACKEND) {
                    delete data.q;
                } else {
                    delete data.backendCategoryIds
                }
                postCategory(data)
                    .then(res => {
                        setSubmitting(false);
                        message.success('保存成功');
                        handleSuccess && handleSuccess();
                        onClose && onClose();
                    }).catch(res => {
                        setSubmitting(false);
                    })
            })
    }

    function fetchCateGoryTree() {
        fetcher.get('api/v2/productcategories', {}, {})
            .then((responese) => {
                CategoryUtils.saveCategoryTree(responese.data);
                responese.data.children.push({
                    category: {
                        id: 'other',
                        displayTerm: 'other',
                        term: 'other',
                    }
                })
                setCategory(responese.data);
                getCategoryFullName(responese.data.children);
                setCategoryNameMap(cMap);
            })
    }

    function getCategoryFullName(children, parentName?) {
        if(children && children.length > 0) {
            children.forEach((item, index) => {
                if(!cMap[item.category.id]) {
                    cMap[item.category.id] = `${item.category.id}-${parentName ? parentName + '-' : ''}${item.category.displayTerm}(${item.category.term})`;
                }
                if(item.children &&  item.children.length > 0) {
                    getCategoryFullName(
                        item.children,
                        `${parentName ? parentName + '-' : ''}${item.category.displayTerm}`
                    )
                }
            })
        }
    }

    function uploadImage(data) {
        const file = data.file;
        let format = file.type.split('/')[1];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function (evt) {
          // 创建image对象
          let image = new Image();
          image.src = evt?.target?.result as string;
          // 获取图片宽高
          image.onload = function () {
            let formData = new FormData();
            formData.append('image', file)
            postImage('FRONTEND_CATEGORY_ICON', formData)
                .then(res => {
                    const { url, width, height } = res?.data || {};
                    setCategroyIcon({
                        url,
                        width,
                        height
                    })
                })
          }
        };
    }

    function handleImgDelete(e) {
        e.stopPropagation();
        setCategroyIcon(null);
    }

    return (
        <Modal
            visible={visible}
            okText="保存"
            cancelText="取消"
            onCancel={onClose}
            onOk={handleSubmit}
            destroyOnClose={true}
            confirmLoading={submitting}
            maskClosable={false}
            title="三级类目"
        >
            <Form {...formItemLayout} form={form} initialValues={{status: 'ONLINE'}}>
                <Form.Item label='名称' name='name' rules={[{ required: true, message: '请输入类目名称' }]}>
                    <Input allowClear />
                </Form.Item>
                <Form.Item label="关联类型">
                    <Radio.Group value={type} onChange={(e) => setType(e?.target?.value)}>
                        <Radio value={TYPE.BACKEND}>后台类目</Radio>
                        <Radio value={TYPE.SEARCH}>搜索词</Radio>
                    </Radio.Group>
                </Form.Item>
                {type === TYPE.BACKEND ?
                    <Form.Item label="后台类目" name='backendCategoryIds' rules={[{ required: true, message: '请选择关联的后台类目' }]}>
                        <TreeSelect
                            showSearch
                            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                            placeholder="Please select"
                            allowClear
                            multiple
                            style={{width: 200}}
                            treeNodeFilterProp="title"
                        >
                            {categories && categories?.category && treeSelect(categories.children)}
                        </TreeSelect>
                    </Form.Item> :
                    <Form.Item label="搜索词" name='q' rules={[{ required: true, message: '请输入搜索词' }]}>
                        <Input allowClear />
                    </Form.Item>
                }
                <Form.Item label='类目icon' name='icon'>
                    <Upload
                        name='icon'
                        listType="picture-card"
                        showUploadList={false}
                        customRequest={uploadImage}
                    >
                        {categroyIcon?.url ?
                            <div className='img-wrap' style={{position: 'relative'}}>
                                <img src={categroyIcon?.url} alt="avatar" style={{ width: '100%' }} />
                                <div className='delete-icon-wrap' onClick={handleImgDelete}>
                                    <MinusCircleOutlined style={{color: '#ffffff'}} />
                                </div>
                            </div> : 
                            <div>
                                上传图片
                            </div>
                        }
                    </Upload>
                </Form.Item>
                <Form.Item label="状态" name='status'>
                    <Radio.Group>
                        <Radio value='ONLINE'>启用</Radio>
                        <Radio value='OFFLINE'>禁用</Radio>
                    </Radio.Group>
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default ThirdModal;